import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';

import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';
import LockIcon from '../LockIcon';
import AccessPayment from '../../AccessPayment';
import { DataContext } from 'contexts';

const LockedFirmInfo = ({isFirst}) => {
    const strings = useLocalized(i18nStrings);
    const { isUser, isOutsideRussia } = useContext(DataContext);

    return (
        <div className={styles['informer']}>
            <div className={styles['text-box']}>
                <LockIcon/>
                {!isUser && isOutsideRussia ? strings.loginText : strings.payText}
            </div>
            {isFirst && (
                <div className={styles['payment']}>
                    <AccessPayment isRow={isOutsideRussia}/>
                </div>
            )}
        </div>
    );
};

export default LockedFirmInfo;

LockedFirmInfo.propTypes = {
    isFirst: PropTypes.bool
};
